import { useQueryTenantInformation } from '@oaknorth/api-polaris';
import { LoadingSpinner } from '@oaknorth/component-core-v2';
import { useFlag } from '@oaknorth/util-feature-flags';
import { Navigate } from '@oaknorth/util-routing';

import { FeatureFlag } from '../constants';
import { HomePage } from '../HomePage';

const CLIMATE_SCORECARD_PATH = 'climate-scorecard/';

export function LandingRedirect() {
  const hasLoanbookAnalysis = useFlag<boolean>(FeatureFlag.HAS_LOANBOOK_ANALYSIS);
  const hasClimateScorecard = useFlag<boolean>(FeatureFlag.HAS_CLIMATE_SCORECARD);
  const getTenantInformation = useQueryTenantInformation({ enabled: hasClimateScorecard });

  if (hasLoanbookAnalysis) {
    return <Navigate to="loanbook-analysis" replace />;
  }
  if (getTenantInformation.isLoading) {
    return <LoadingSpinner />;
  }
  if (hasClimateScorecard === true && getTenantInformation.data?.is_scorecard_tenant === true) {
    <Navigate to={CLIMATE_SCORECARD_PATH} replace />;
  }
  return <HomePage />;
}
